import * as types from './actionTypes';  
import dspUsersApi from '../api/dspUsersApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doDspUsersList(ext_id) {

  return {
    type: types.DO_DSP_USERS_LIST, 
    ext_id
  };
}

export function doDspUsersListRes(data) {  
  return {
    type: types.DO_DSP_USERS_LIST_RES, 
    data
  };
}

export function getDspUsers(ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      dspUsersApi.doDspUsersList(ext_id).then(data => {
        dispatch(doDspUsersListRes(data));
        dispatch(doDspUsersListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
  
}